"use client";
import React, { useState, useEffect, useRef } from "react";
import { Logo } from "@/assets";
import Link from "next/link";
import { SlMenu } from "react-icons/sl";
import { Drawer, ConfigProvider } from "antd";
import { Menu } from "antd";
import { usePathname } from "next/navigation";
import Image from "next/image";
import {
  PenLine,
  BookOpen,
  Megaphone,
  PenTool,
  LayoutTemplate,
  Baby,
  ChevronDown,
  ArrowRight,
} from "lucide-react";
import { LiveChatButton, ButtonCta, TopBar } from "@/components";
function HeaderNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("0");
  const [servicesOpen, setServicesOpen] = useState(false);
  const closeTimer = useRef(null);
  const pathname = usePathname();

  const isActive = (href) => {
    const p = (pathname || "").replace(/\/$/, "");
    return p === href.replace(/\/$/, "");
  };

  const openServices = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setServicesOpen(true);
  };
  const closeServices = () => {
    closeTimer.current = setTimeout(() => setServicesOpen(false), 120);
  };

  const primaryLinks = [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about-us" },
  ];
  const trailingLinks = [
    { label: "Contact Us", href: "/contact-us" },
    { label: "FAQs", href: "/faq" },
  ];
  const serviceLinks = [
    {
      title: "Book Writing",
      href: "/book-writing",
      desc: "Ghostwriting that turns your idea into a finished manuscript.",
      Icon: PenLine,
    },
    {
      title: "Book Publishing",
      href: "/book-publishing",
      desc: "Get published across Amazon, Kindle & major retailers.",
      Icon: BookOpen,
    },
    {
      title: "Book Marketing",
      href: "/book-marketing",
      desc: "Reach the right readers with targeted campaigns.",
      Icon: Megaphone,
    },
    {
      title: "Book Editing",
      href: "/book-editing",
      desc: "Editing & proofreading that polish every page.",
      Icon: PenTool,
    },
    {
      title: "Book Design",
      href: "/book-design",
      desc: "Custom covers & interior layouts built for your genre.",
      Icon: LayoutTemplate,
    },
    {
      title: "Children Book Writing",
      href: "/children-book-writing",
      desc: "Playful stories & art crafted for young readers.",
      Icon: Baby,
    },
  ];
  const onClick = (e) => {
    // localStorage?.setItem("navKey", e.key);
    // setCurrent(e.key);
  };
  // console.log("here is pathname", pathname)
  const onClose = (e) => {
    // localStorage?.setItem("navKey", e.key);
    // setCurrent(e.key);
    // setTimeout(() => {
    setOpen(false);
    // }, 0);
  };

  const items = [
        {
      label: (
        <Link
          onClick={onClose}
          className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
            } ${pathname === "/" ? "!text-brand-600" : ""}`}
          href={"/"}
        >
          Home
        </Link>
      ),
      key: "100",
    },
    {
      label: (
        <Link
          onClick={onClose}
          className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
            } ${pathname === "/about-us/" ? "!text-brand-600" : ""}`}
          href={"/about-us"}
        >
          About Us
        </Link>
      ),
      key: "1",
    },


    {
      label: (
        <p className="flex gap-2 justify-center uppercase items-center">
          Services
          {/* <RiArrowDownSLine className="pt-1" /> */}
        </p>
      ),
      key: "5",
      children: [
        // {
        //   label: (
        //     <Link
        //       onClick={onClose}
        //       className={`hover:text-gold uppercase  ${
        //         scrolled ? "text-black " : open ? "text-black " : "text-black"
        //       }`}
        //       href={"/ghost-writing"}
        //     >
        //       GHOSTWRITING
        //     </Link>
        //   ),
        //   key: "51",
        // },

        // {
        //   label: (
        //     <Link
        //       onClick={onClose}
        //       className={`hover:text-gold uppercase  ${
        //         scrolled ? "text-black " : open ? "text-black " : "text-black"
        //       }`}
        //       href={"/ebook-writing"}
        //     >
        //       EBOOK WRITING
        //     </Link>
        //   ),
        //   key: "52",
        // },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/book-writing/" ? "!text-brand-600" : ""}`}
              href={"/book-writing"}
            >
              BOOK WRITING
            </Link>
          ),
          key: "53",
        },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/book-publishing/" ? "!text-brand-600" : ""}`}
              href={"/book-publishing"}
            >
              BOOK PUBLISHING
            </Link>
          ),
          key: "54",
        },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/book-marketing/" ? "!text-brand-600" : ""}`}
              href={"/book-marketing"}
            >
              BOOK MARKETING
            </Link>
          ),
          key: "55",
        },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/book-editing/" ? "!text-brand-600" : ""}`}
              href={"/book-editing"}
            >
              BOOK EDITING
            </Link>
          ),
          key: "56",
        },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/book-design/" ? "!text-brand-600" : ""}`}
              href={"/book-design"}
            >
              BOOK DESIGN
            </Link>
          ),
          key: "57",
        },
        {
          label: (
            <Link
              onClick={onClose}
              className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
                } ${pathname === "/children-book-writing/" ? "!text-brand-600" : ""}`}
              href={"/children-book-writing"}
            >
              CHILDREN BOOK WRITING
            </Link>
          ),
          key: "58",
        },
        // {
        //   label: (
        //     <Link
        //       onClick={onClose}
        //       className={`hover:text-gold uppercase  ${
        //         scrolled ? "text-black " : open ? "text-black " : "text-black"
        //       }`}
        //       href={"/business-writing"}
        //     >
        //       BUSINESS BOOK
        //     </Link>
        //   ),
        //   key: "55",
        // },


        // {
        //   label: (
        //     <Link
        //       onClick={onClose}
        //       className={`hover:text-gold uppercase  ${
        //         scrolled ? "text-black " : open ? "text-black " : "text-black"
        //       }`}
        //       href={"/book-marketing"}
        //     >
        //       BOOK MARKETING
        //     </Link>
        //   ),
        //   key: "62",
        // },
      ],
    },
    // {
    //   label: (
    //     <Link
    //       onClick={onClose}
    //       className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
    //         } ${pathname === "/pricing/" ? "!text-brand-600" : ""}`}
    //       href={"/pricing"}
    //     >
    //       Pricing
    //     </Link>
    //   ),
    //   key: "7",
    // },
    {
      label: (
        <Link
          onClick={onClose}
          className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
            } ${pathname === "/contact-us/" ? "!text-brand-600" : ""}`}
          href={"/contact-us"}
        >
          Contact Us
        </Link>
      ),
      key: "3",
    },
        {
      label: (
        <Link
          onClick={onClose}
          className={`hover:text-gold uppercase  ${scrolled ? "text-black " : open ? "text-black " : "text-black"
            } ${pathname === "/faq/" ? "!text-brand-600" : ""}`}
          href={"/faq"}
        >
          FAQs
        </Link>
      ),
      key: "98",
    },

    // {
    //   label: <></>,
    //   key: "12",
    // },
  ];
  useEffect(() => {
    // let selectedRoute = localStorage?.getItem("navKey");
    // setCurrent(selectedRoute);
  }, []);
  const showDrawer = () => {
    setOpen(true);
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const headerClass = scrolled
    ? "header-default header-scrolled "
    : "header-default xl:pt-[0rem] lg:pt-[0rem] md:pt-[0rem] sm:pt-[0rem] fl:pt-[0rem]";

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    onClick();
    setCollapsed(!collapsed);
  };
  return (
    <nav
      className={`flex  justify-center flex-col items-center main_header ${scrolled ? "" : "bg-paper/95 backdrop-blur-sm shadow-sm"} ${headerClass}`}
    >
      <TopBar />
      <div
        className={`flex max-w-[1350px]  items-center px-2  md:px-5 lg:px-0 py-0  ${!scrolled && "fl:py-0 md:py-0"
          }  justify-between  w-[95%] `}
      >
        
        <Link
          href={"/"}
          onClick={() => {
            localStorage?.setItem("navKey", "0");
            setCurrent("0");
          }}
          className=""
        >
          {/* <h1 className="text-black text-5xl font-bold whitespace-nowrap">
            LOGO
          </h1> */}
          <Image
            src={Logo}
            alt="logo-image"
            className="xl:h-24
             lg:h-20 md:h-20  sm:h-16 fl:h-16  w-72 object-contain"
          />
        </Link>
        <div className="flex flex-1  ">
          <div className="flex-1 lg:flex fl:hidden items-center justify-end xl:pr-10 lg:pr-6">
            <ul className="flex items-center gap-6 xl:gap-8 xl:text-[0.9em] lg:text-[0.82em] font-sans font-medium">
              {primaryLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className={`group relative inline-flex items-center uppercase tracking-wide transition-colors hover:text-brand-600 ${
                      isActive(link.href) ? "text-brand-600" : "text-ink"
                    }`}
                  >
                    {link.label}
                    <span
                      className={`pointer-events-none absolute -bottom-1.5 left-0 h-0.5 rounded-full bg-brand-600 transition-all duration-300 ${
                        isActive(link.href) ? "w-full" : "w-0 group-hover:w-full"
                      }`}
                    />
                  </Link>
                </li>
              ))}

              {/* Services — mega menu on hover */}
              <li
                className="relative"
                onMouseEnter={openServices}
                onMouseLeave={closeServices}
              >
                <button
                  type="button"
                  aria-expanded={servicesOpen}
                  className={`group relative inline-flex items-center gap-1 uppercase tracking-wide transition-colors hover:text-brand-600 ${
                    servicesOpen ||
                    serviceLinks.some((s) => isActive(s.href))
                      ? "text-brand-600"
                      : "text-ink"
                  }`}
                >
                  Services
                  <ChevronDown
                    size={15}
                    className={`transition-transform duration-300 ${
                      servicesOpen ? "rotate-180" : ""
                    }`}
                  />
                  <span
                    className={`pointer-events-none absolute -bottom-1.5 left-0 h-0.5 rounded-full bg-brand-600 transition-all duration-300 ${
                      servicesOpen || serviceLinks.some((s) => isActive(s.href))
                        ? "w-full"
                        : "w-0 group-hover:w-full"
                    }`}
                  />
                </button>

                {/* Panel */}
                <div
                  className={`absolute left-1/2 top-full z-50 -translate-x-1/2 pt-4 transition-all duration-200 ease-out ${
                    servicesOpen
                      ? "visible translate-y-0 opacity-100"
                      : "invisible -translate-y-1 opacity-0"
                  }`}
                >
                  <div className="w-[min(42rem,80vw)] overflow-hidden rounded-2xl border border-gold/30 bg-paper shadow-editorial">
                    {/* Header strip */}
                    <div className="relative flex items-center justify-between gap-4 overflow-hidden bg-ink bg-paper-grain px-6 py-4">
                      <div
                        aria-hidden
                        className="pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-brand-500/25 blur-2xl"
                      />
                      <div className="relative">
                        <span className="eyebrow flex items-center gap-2 text-gold-soft">
                          <span className="h-px w-6 bg-gold/70" />
                          What We Do
                        </span>
                        <p className="mt-1 font-display text-lg font-semibold text-white">
                          Publishing Services
                        </p>
                      </div>
                      <Link
                        href="/contact-us"
                        onClick={() => setServicesOpen(false)}
                        className="relative inline-flex shrink-0 items-center gap-1.5 rounded-full border border-gold/50 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white transition-colors hover:bg-gold/15"
                      >
                        Get a Quote
                        <ArrowRight size={14} />
                      </Link>
                    </div>

                    {/* Service grid */}
                    <div className="grid grid-cols-2 gap-1 p-3">
                      {serviceLinks.map(({ title, href, desc, Icon }) => {
                        const active = isActive(href);
                        return (
                          <Link
                            key={href}
                            href={href}
                            onClick={() => setServicesOpen(false)}
                            className={`group/card flex items-start gap-3 rounded-xl p-3 transition-colors ${
                              active ? "bg-cream" : "hover:bg-cream"
                            }`}
                          >
                            <span
                              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors ${
                                active
                                  ? "bg-brand-600 text-white"
                                  : "bg-brand-50 text-brand-600 group-hover/card:bg-brand-600 group-hover/card:text-white"
                              }`}
                            >
                              <Icon size={18} strokeWidth={1.8} />
                            </span>
                            <span className="flex flex-col">
                              <span
                                className={`flex items-center gap-1 font-display text-sm font-semibold transition-colors ${
                                  active
                                    ? "text-brand-600"
                                    : "text-ink group-hover/card:text-brand-600"
                                }`}
                              >
                                {title}
                                <ArrowRight
                                  size={13}
                                  className="-translate-x-1 opacity-0 transition-all duration-200 group-hover/card:translate-x-0 group-hover/card:opacity-100"
                                />
                              </span>
                              <span className="mt-0.5 text-xs leading-snug text-ink-soft">
                                {desc}
                              </span>
                            </span>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </li>

              {trailingLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className={`group relative inline-flex items-center uppercase tracking-wide transition-colors hover:text-brand-600 ${
                      isActive(link.href) ? "text-brand-600" : "text-ink"
                    }`}
                  >
                    {link.label}
                    <span
                      className={`pointer-events-none absolute -bottom-1.5 left-0 h-0.5 rounded-full bg-brand-600 transition-all duration-300 ${
                        isActive(link.href) ? "w-full" : "w-0 group-hover:w-full"
                      }`}
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex my-auto justify-end items-end w-full px-3 xl:hidden lg:hidden md:visible sm:visible fl:visible">
            <SlMenu
              onClick={showDrawer}
              className={`font-bold ${scrolled ? "text-black " : "text-black"
                } text-2xl justify-self-end self-end`}
            />
            <Drawer
              className="text-center"
              title="Menu"
              placement="right"
              onClose={onClose}
              open={open}
            >
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#1EA7DB",
                  },

                  components: {
                    Menu: {
                      itemActiveBg: "#1EA7DB",
                      itemSelectedBg: "#1EA7DB",
                      itemSelectedColor: "black",
                    },
                  },
                }}
              >
                <Menu
                  mode="inline"
                  theme="light"
                  inlineCollapsed={collapsed}
                  items={items}
                />
              </ConfigProvider>
              <div className=" flex flex-col w-full gap-5 py-8">
            <ButtonCta buttonText="Get Started" classStyle={`text-white bg-brand-600 hover:bg-brand-700 py-2 flex justify-center items-center `} />
            <LiveChatButton classStyle={`text-ink bg-transparent border border-gold/60 hover:bg-gold/10 py-2 flex justify-center items-center `} buttonText="Live Chat" />
          </div>
            </Drawer>

          </div>
          <div className="hidden md:flex gap-5">
            <ButtonCta  buttonText="Get Started" classStyle={`text-white bg-brand-600 hover:bg-brand-700 `} />
            <LiveChatButton classStyle={`text-ink bg-transparent border border-gold/60 hover:bg-gold/10`} buttonText="Live Chat" />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default HeaderNav;
